"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcquiredSpaceAgency = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var AcquiredSpaceAgency = (function (_super) {
    __extends(AcquiredSpaceAgency, _super);
    function AcquiredSpaceAgency() {
        return _super.call(this, {
            name: CardName_1.CardName.ACQUIRED_SPACE_AGENCY,
            metadata: {
                cardNumber: 'P35',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.titanium(6, { digit: true }).br.br;
                    b.cards(2, { secondaryTag: Tags_1.Tags.SPACE });
                }),
                description: 'Gain 6 titanium. Reveal cards until you reveal two cards with Space Tags. Take them into your hand, discard the rest.',
            },
        }) || this;
    }
    AcquiredSpaceAgency.prototype.play = function (player) {
        player.titanium += 6;
        player.drawCard(2, { tag: Tags_1.Tags.SPACE });
        return undefined;
    };
    ;
    return AcquiredSpaceAgency;
}(PreludeCard_1.PreludeCard));
exports.AcquiredSpaceAgency = AcquiredSpaceAgency;
